import RestCrudThunks from './restCrudThunksGenerator';
import { QUOTE_DOWNLOAD_FORMATS_CRUD_ACTION_CREATORS } from '../actions/quote_download_formats_actions';
import { ROLE_TYPES } from '../utils/DataConstants';

export const quoteDownloadFormatsRestCrudThunksForBuyer = new RestCrudThunks(
	'quote_download_formats',
	'quote_download_format',
	'quoteDownloadFormat',
	'quoteDownloadFormats',
	QUOTE_DOWNLOAD_FORMATS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'quote/'
);

export const quoteDownloadFormatsRestCrudThunksForSupplier = new RestCrudThunks(
	'quote_download_formats',
	'quote_download_format',
	'quoteDownloadFormat',
	'quoteDownloadFormats',
	QUOTE_DOWNLOAD_FORMATS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'quote/'
);
